exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".radio-button {\n  float: right;\n  margin-top: 10px; }\n\n.list-item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 20px; }\n\n.list-item mat-icon {\n  margin-right: 10px; }\n\n.list-item h4,\n.list-item p {\n  margin: 0; }\n\n.list-item p {\n  white-space: pre-wrap; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/notificacao/notificacao/notificacao.component.scss
// module id = ../../../../../src/app/components/notificacao/notificacao/notificacao.component.scss
// module chunks = main